var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { AppState } from "@/share/AppState";
import { ExternalEditOpt } from "@/share/ExternalContactEdit";
import { MasterKeyRequestType } from "@/share/MasterKeyReq";
import { UserStatus } from "@@/Group";
import { action, makeObservable, observable } from "mobx";
// import { CompanyContact, DiscoverResult, MiniContactInfo } from "../../../letrcore/Group";
// import { Header } from "../../../letrcore/Response";
// import { AEvent } from "../../Events/AppEvent";
// import { LoginStage } from "../../models/LoginState";
// import { CService } from "../../service/GroupService";
// import { shareLib } from "../../util/RequestUtil";
export class UserContactStore {
    // public header: Header[] = [];
    constructor() {
        this.myteam = new Map();
        this.myletrwingcontacts = new Map();
        this.appcon = new Map();
        this.orgcontacts = new Map();
        this.loadingmyteam = false;
        this.loadingmylcontacts = false;
        this.loadingcompanycontacts = false;
        this.discovering = false;
        this.dintfinddisc = -1;
        this.showaddmember = false;
        this.showexternalcontactlist = false;
        this.loadingappcontacts = false;
        this.delids = new Set();
        this.masterkey = "";
        this.orgid = "";
        makeObservable(this);
        // AEvent.addSubscriberForLoginStage(async (st) =>{
        //     if(st === LoginStage.Loggedin) {
        //         this.header = await shareLib.getRequestHeaders();
        //     }
        // })
        APPEvent.addSubscriberForOrgID((id) => this.orgid = id);
        APPEvent.addSubscriberForActivateUser((res) => {
            if (res.success) {
                this.activateUser(res.userid);
            }
        });
        APPEvent.addSubscriberForAppState((st) => {
            if (st === AppState.LoggedIn) {
                this.loadMyteam();
                this.loadMyLetrwingContacts();
                this.loadCompanyLetrwingContacts();
            }
            else {
                this.masterkey = "";
                this.clearAppContacts();
            }
        });
        APPEvent.addSubscriberForAdminUpdateUserDetailRes((res) => {
            if (res.success) {
                const userid = this.orgid + "__<<>>__" + res.userid;
                this.updateMyTeam(Object.assign(Object.assign({}, res), { userid: userid }));
            }
        });
        APPEvent.addSubscriberForAdminEditUserRequestRes((res) => {
            if (res.length > 0) {
                if (res[0].success && res[0].status !== undefined) {
                    this.updateMyTeam(Object.assign({}, res[0]));
                }
            }
        });
        APPEvent.addSubscriberForGetMyTeamRes((ret) => {
            if (ret !== undefined) {
                for (const r of ret) {
                    this.addTeam(r);
                }
            }
            // now lets just adjust 
            this.setLoadingMyTeam(false);
        });
        APPEvent.addSubscriberForGetMyLetrwingContactRes((ret) => {
            if (ret !== undefined) {
                for (const r of ret) {
                    this.addMyLetrwingContact(r);
                }
            }
            this.setLoadingMyContacts(false);
        });
        APPEvent.addSubscriberForGetAppUser((us) => {
            if (us.type === 'get') {
                if (us.ok) {
                    // we should add these now!!
                    for (const u of us.us) {
                        this.addAppUser(u);
                    }
                }
                this.setLoadingAppUsers(false);
            }
        });
        APPEvent.addSubscriberForAddAppUser((us) => {
            if (us.type === 'add') {
                if (us.ok) {
                    // we should add these now!!
                    for (const u of us.us) {
                        this.addAppUser(u);
                    }
                }
            }
        });
        APPEvent.addSubscriberForDeleteAppUser((ud) => {
            if (ud.delids) {
                for (const d of ud.delids) {
                    this.removeAppCon(d);
                    this.removeContactToDel(d);
                }
            }
        });
        APPEvent.addSubscriberForCompanyDirectory((ret) => {
            this.setLoadingMyCompanyContacts(false);
            if (ret !== undefined) {
                for (const r of ret) {
                    this.addCompanyContact(r);
                }
            }
        });
        APPEvent.addSubscriberForExternalContactResponse((res) => this.editExternalContactResponse(res));
        APPEvent.addSubscriberForAdminDeleteUser((del) => {
            if (del.success) {
                this.removeTeammem(del.userid);
            }
        });
        APPEvent.addSubscriberForMasterKeyResponse((req) => {
            if (req.type === MasterKeyRequestType.GetM) {
                this.masterkey = req.masterkey;
                this.loadAppUsers();
            }
        });
        APPEvent.addSubscriberForUpdateAppUser((us) => {
            if (us.type === 'update') {
                if (us.ok) {
                    // we should add these now!!
                    for (const u of us.us) {
                        this.addAppUser(u);
                    }
                }
            }
        });
        makeObservable(this);
    }
    activateUser(id) {
        const ucon = this.myteam.get(id);
        if (ucon) {
            ucon.userstatus = UserStatus.Active;
        }
        if (this.activeprofile && this.activeprofile.id === id) {
            this.activeprofile.userstatus = UserStatus.Active;
        }
    }
    addAppUser(user) {
        this.appcon.set(user.id, user);
    }
    updateMyTeam(upd) {
        const ucon = this.myteam.get(upd.userid);
        if (ucon) {
            if (upd.name) {
                ucon.name = upd.name;
            }
            if (upd.newrole) {
                ucon.role = upd.newrole;
            }
            if (upd.status) {
                ucon.userstatus = upd.status;
            }
        }
        if (this.activeprofile && this.activeprofile.id === upd.userid) {
            if (upd.name) {
                this.activeprofile.name = upd.name;
            }
            if (upd.status) {
                this.activeprofile.userstatus = upd.status;
            }
        }
    }
    addActiveProfile(pro) {
        this.activeprofile = pro;
    }
    removeTeammem(mem) {
        const memb = this.myteam.get(mem);
        if (memb) {
            if (memb.userstatus === UserStatus.PendingIdentity) {
                this.myteam.delete(mem);
            }
            else {
                memb.userstatus = UserStatus.Inactive;
            }
        }
    }
    editExternalContactResponse(res) {
        res.forEach((r) => {
            if (r.success && r.editopt === ExternalEditOpt.Delete) {
                this.myletrwingcontacts.delete(r.grp.userid);
            }
        });
    }
    setshowAddMember(show) {
        this.showaddmember = show;
    }
    setShowExternalContactList(show) {
        this.showexternalcontactlist = show;
    }
    // public getHeader(id: string, size: number) {
    //     const ret: any = {};
    //     this.header.forEach((h) => ret[h.key] = h.value);
    //     ret["X-Profile-ID"] = id;
    //     ret["X-Profile-Size"] = size + "";
    //     return ret;
    // }
    loadAppUsers() {
        this.setLoadingAppUsers(true);
        this.clearAppContacts();
        const req = {
            mk: this.masterkey,
            us: []
        };
        Apphandler.sendMessage("getappusers", req);
    }
    loadMyteam() {
        this.setLoadingMyTeam(true);
        this.clearMyTeam();
        // const res = await CService.getMyTeam();
        Apphandler.sendMessage("getmyteam", "");
    }
    async loadMyLetrwingContacts() {
        this.setLoadingMyContacts(true);
        this.clearMyLetrwingContacts();
        Apphandler.sendMessage("getmyletrwingcontacts", "");
    }
    async discoverByEmail(email) {
        this.setDiscovering(true);
        // const res = await CService.discoverEmail(email);
        // if(res === undefined) {
        //     this.setDiscoverRes(0);
        // }else {
        //     this.setDiscoverRes(1);
        // }
        // this.setDiscoverResult(res);
        this.setDiscovering(false);
    }
    async discoverByPhoneNumber(phonenumber) {
        this.setDiscovering(true);
        // const res = await CService.discoverPhonenumber(phonenumber);
        // if(res === undefined) {
        //     this.setDiscoverRes(0);
        // }else {
        //     this.setDiscoverRes(1);
        // }
        // this.setDiscoverResult(res);
        this.setDiscovering(false);
    }
    async loadCompanyLetrwingContacts() {
        this.setLoadingMyCompanyContacts(true);
        Apphandler.sendMessage("getcompanydirectory", "");
        // this.clearMyCompanyContacts();
        // const res = await CService.getCompanyDirectory();
        // if (res !== undefined) {
        //     for(const r of res) {
        //         this.addCompanyContact(r);
        //     }
        // }
        this.setLoadingMyCompanyContacts(false);
    }
    async deleteAppContact(id) {
        this.addContactToDel(id);
        const req = [id];
        Apphandler.sendMessage("deleteappusers", req);
    }
    setDiscoverRes(res) {
        this.dintfinddisc = res;
    }
    setDiscoverResult(res) {
        this.discovres = res;
    }
    setDiscovering(dis) {
        this.discovering = dis;
    }
    clearMyLetrwingContacts() {
        this.myletrwingcontacts.clear();
    }
    clearMyTeam() {
        this.myteam.clear();
    }
    clearAppContacts() {
        this.appcon.clear();
        this.delids.clear();
    }
    addContactToDel(id) {
        this.delids.add(id);
    }
    removeAppCon(id) {
        this.appcon.delete(id);
    }
    removeContactToDel(id) {
        this.delids.delete(id);
    }
    clearMyCompanyContacts() {
        this.orgcontacts.clear();
    }
    addTeam(team) {
        this.myteam.set(team.id, team);
    }
    removeMyContact() {
    }
    addMyLetrwingContact(r) {
        this.myletrwingcontacts.set(r.id, r);
    }
    addCompanyContact(con) {
        this.orgcontacts.set(con.id, con);
    }
    setLoadingAppUsers(loading) {
        this.loadingappcontacts = loading;
    }
    setLoadingMyTeam(loading) {
        this.loadingmyteam = loading;
    }
    setLoadingMyContacts(loading) {
        this.loadingmylcontacts = loading;
    }
    setLoadingMyCompanyContacts(loading) {
        this.loadingcompanycontacts = loading;
    }
    reset() {
    }
    getMyLetrwingContacts() {
        return Array.from(this.myletrwingcontacts.values()).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }
    getAppContacts() {
        return Array.from(this.appcon.values()).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }
    getMyTeam() {
        return Array.from(this.myteam.values()).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }
    getMyOrgDirectory() {
        return Array.from(this.orgcontacts.values()).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], UserContactStore.prototype, "myteam", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], UserContactStore.prototype, "myletrwingcontacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], UserContactStore.prototype, "appcon", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], UserContactStore.prototype, "orgcontacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserContactStore.prototype, "loadingmyteam", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserContactStore.prototype, "loadingmylcontacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserContactStore.prototype, "loadingcompanycontacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserContactStore.prototype, "discovering", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserContactStore.prototype, "discovres", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserContactStore.prototype, "dintfinddisc", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserContactStore.prototype, "showaddmember", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserContactStore.prototype, "showexternalcontactlist", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserContactStore.prototype, "activeprofile", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserContactStore.prototype, "loadingappcontacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], UserContactStore.prototype, "delids", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "activateUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "addAppUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "updateMyTeam", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "addActiveProfile", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "removeTeammem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "editExternalContactResponse", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "setshowAddMember", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "setShowExternalContactList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "setDiscoverRes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "setDiscoverResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "setDiscovering", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "clearMyLetrwingContacts", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "clearMyTeam", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "clearAppContacts", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "addContactToDel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "removeAppCon", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "removeContactToDel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "clearMyCompanyContacts", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "addTeam", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "removeMyContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "addMyLetrwingContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "addCompanyContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "setLoadingAppUsers", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "setLoadingMyTeam", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "setLoadingMyContacts", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserContactStore.prototype, "setLoadingMyCompanyContacts", null);
